import {ReceiptExpensesType, SiteTargetType} from "@/enums/type";
import {DebtCustomer} from "@/interfaces/entity";
import {DebtCustomerStatus} from "@/enums/status/debtcustomer";
import moment from "moment";

export class ExpenseCustomerParams {
    page = 1;
    limit = 10;
    customerRowGuid?: string;
    employeeServiceRowGuid?: string;
    fromDate = moment().startOf('month').valueOf();
    toDate = (new Date()).valueOf();
    type = ReceiptExpensesType.PickingListPay;
    status = DebtCustomerStatus.NotYetPay;
    revenueExpenditureId?: number;
}
